import { useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { useSelector } from "react-redux";
import { checkCalculatedAccountBalance, getTotalVoucherCount } from "../../../Utils/AllPagesQuriesAndMutations";
import { Loading, LoadTable } from "../../Components";
import Button from "../../Components/Button/Button";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import Input from "../../Components/Input/Input";
import "./SingleAccountCheck.scss";

const SingleAccountCheck = () => {
  const [formData, setFormData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [selectedAccountBalance, setSelectedAccountBalance] = useState({});
  const [totalVoucherCount, setTotalVoucherCount] = useState({ Total_Voucher_Count: 0 });
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [searchText, setSearchText] = useState("");
  const [previousBalances, setPreviousBalances] = useState([]);
  const [monthlyBalances, setMonthlyBalances] = useState([]);

  const Key = "Single_Account_Check";

  const [calculateAccountBalance, { loading: queryLoading }] = useLazyQuery(checkCalculatedAccountBalance, {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoader(false);
    },
    onError: () => {
      setIsLoader(false);
    },
  });

  const [fetchTotalVoucherCount, { loading: totalVoucherCountLoading }] = useLazyQuery(getTotalVoucherCount, {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoader(false);
    },
    onError: () => {
      setIsLoader(false);
    },
  });

  const handleGo = async () => {
    await calculateAccountBalance({
      variables: {
        accountBalanceId: selectedAccountBalance.Account_Balance_Id,
      },
    }).then(({ data }) => {
      console.log(data);
      if (data?.checkCalculatedAccountBalance) {
        setFormData(data?.checkCalculatedAccountBalance);
        setPreviousBalances(data?.checkCalculatedAccountBalance[0]?.Previous_monthlyBalances);
        setMonthlyBalances(data?.checkCalculatedAccountBalance[0]?.monthlyBalances);
      }
    });

    await fetchTotalVoucherCount({
      variables: {
        accountBalanceId: selectedAccountBalance.Account_Balance_Id,
      },
    }).then(({ data }) => {
      console.log(data);
      if (data?.getVoucherCount) {
        setTotalVoucherCount(data?.getVoucherCount);
      }
    });
  };

  const handleChange = (e) => {
    console.log(e, e?.target?.value);
    setSearchText(e?.target?.value || "");
    const accountBalanceData = FormDataFromRedux?.MasterData[Key]?.accountBalanceId;
    setSelectedAccountBalance(accountBalanceData);
  };

  const isLoading = queryLoading || totalVoucherCountLoading || isLoader;

  return (
    <>
      <HeaderDiv title="Single Accounting Check" />
      <div className="AccountDetailsDiv">
        <div>
          <p className="heading">Account</p>
          <p>{formData && (formData[0]?.Account_Name || "-")} </p>
        </div>
        <div>
          <p className="heading">Group name</p>
          <p className="closingBalance">{formData && (formData[0]?.Account_Group || "-")}</p>
        </div>
        <div>
          <p className="heading">Opening valance</p>
          <p>
            {formData && formData[0]?.Opening_Balance == null
              ? "0"
              : `${formData[0].Opening_Balance} ${formData[0].Opening_Balance < 0 ? "Cr" : "Dr"}`}
          </p>
        </div>
        <div>
          <p className="heading">Previous account balance</p>
          <p>{formData && (formData[0]?.Previous_Account_Balance || 0)}</p>
        </div>{" "}
        <div>
          <p className="heading">Account balance</p>
          <p>{formData && (formData[0]?.Account_Balance || 0)}</p>
        </div>
        <div>
          <p className="heading">Total voucher count</p>
          <p className="closingBalance">{totalVoucherCount?.Total_Voucher_Count}</p>
        </div>
      </div>

      <div className="UserRightsContainer">
        <div className="RightsHeader">
          <div className="RightsHeaderDiv">
            <Input
              EMTQuery=""
              checked={""}
              InputConfig={{
                masterName: "AllAccountBalance",
              }}
              type="InputDropForQuery"
              name="accountBalanceId"
              handleBlur={() => {}}
              handleInputChange={(e) => {
                handleChange(e);
              }}
              label={"Select account"}
              modalform={true}
              Iconinside={true}
              formkey={Key}
              value={searchText}
            />
            <Button name="gobutton" text="GO" action={handleGo}></Button>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="single_check_account_balance_previous_afterCheck_Main_Container">
          <div>
            {previousBalances?.length > 0 ? (
              <>
                <h5>Previous monthly account balance</h5>
                <LoadTable data={previousBalances} loading={isLoading} title={Key} settings={false} options={false}/>
              </>
            ) : (
              <p className="DataNotAvailable">Data not available</p>
            )}
          </div>
          <div>
            {monthlyBalances?.length > 0 ? (
              <>
                {" "}
                <h5>After check monthly account balance</h5>
                <LoadTable data={monthlyBalances} loading={isLoading} title={Key} settings={false} options={false}/>
              </>
            ) : (
              <p className="DataNotAvailable">Data not available</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SingleAccountCheck;
